<template>
    <div>
        <CRow>
            <CCol sm="12">
                <CCard>
                    <CCardHeader>
                    آخرین گزارش
                    </CCardHeader>
                    <CCardBody>
                        <CRow>
                            <CCol sm="6" lg="3">
                                <CWidgetDropdown style="height:100px"  color="info" :header="items[0]" text="تاریخ">
                                </CWidgetDropdown>
                            </CCol>
                            <CCol sm="6" lg="3">
                            <CWidgetDropdown style="height:100px" color="primary" :header="items[1]" :text="`پیام به ${operators_count} اپراتور`" >
                                <template #default>
                                <CDropdown
                                    color="transparent p-0"
                                    placement="bottom-end"
                                >
                                    <template #toggler-content>
                                    <CIcon name="cil-settings"/>
                                    </template>
                                    <CDropdownItem><CButton @click="messages_modal=true" class="mr-1">
                                        آمار پیام‌ها
                                    </CButton></CDropdownItem>
                                    <CDropdownItem><CButton @click="operators_modal=true" class="mr-1">
                                        آمار اپراتورها
                                    </CButton></CDropdownItem>
                                </CDropdown>
                                </template>
                            </CWidgetDropdown>
                            </CCol>
                            <CCol sm="6" lg="3">
                            <CWidgetDropdown style="height:100px"  color="warning" :header="items[6]" text="هزینه پیام‌ها (ریال)">
                            </CWidgetDropdown>
                            </CCol>
                            <CCol sm="6" lg="3">
                            <CWidgetDropdown style="height:100px"  color="danger" :header="items[7]" text="مبلغ برگشتی (ریال)">
                            </CWidgetDropdown>
                            </CCol>
                        </CRow>
                    </CCardBody>
                </CCard>
               <CRow>
                    <CCol sm="12" v-show="$store.state.perms.can_view_all_user_send_rcv_into_data_for_all_users">
                        <CButton @click="collapse=!collapse" color="primary" class="mb-2">
                            فیلتر داده‌ها
                        </CButton>
                        <CCollapse :show="collapse" :duration="400">
                            <CCard>
                                <CCardHeader>
                                    <strong>گزینه‌های فیلتر</strong>
                                </CCardHeader>
                                <CCardBody>
                                    <CRow>
                                        <CCol sm="3">
                                            <label>کاربر</label>
                                            <model-select :options="users" v-model="$store.state.u_id" placeholder="انتخاب کنید">
                                            </model-select>
                                        </CCol>
                                    </CRow>
                                    <br>
                                    <div class="form-group form-actions">
                                        <CButton @click="filter" class="ml" color="primary">فیلتر</CButton>
                                        <CButton @click="remove_filter" color="danger">حذف فیلتر</CButton>
                                    </div>
                                </CCardBody>
                            </CCard>
                        </CCollapse>
                    </CCol>
               </CRow>
                <CCard v-show="$store.state.perms.can_view_monitoring_page">
                    <CCardHeader>
                        نمودار گزارش لحظه‌ای
                        <br>
                        <small>در صورت وجود گزارش، نمودار هر دقیقه به‌روزرسانی می‌شود.</small>
                    </CCardHeader>
                    <CCardBody>
                        <div id="chart">
                            <apexchart type="line" height="500" :options="chartOptions" :series="series"></apexchart>
                        </div>
                    </CCardBody>
                </CCard>
                <CCard v-show="$store.state.perms.can_view_news">
                    <CCardHeader>
                        اطلاعیه‌ها
                    </CCardHeader>
                    <CCardBody>
                        <CRow>
                            <CCol col="12">
                                <CDataTable hover striped :items="news" :fields="fields">
                                    <template #news_title="data">
                                        <td>
                                            <CButton color="link" @click="news_text=data.item.news_text;news_modal=true">
                                                {{data.item.news_title}}
                                            </CButton>
                                        </td>
                                    </template>
                                </CDataTable>
                                <div> 
                                <CPagination
                                    :activePage.sync="page"
                                    :pages="page_count"
                                    align="center"
                                    :doubleArrows="true"
                                />
                                </div>
                            </CCol>
                        </CRow>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
        <CModal
			title="متن اطلاعیه"
			size="lg"
			color="primary"
			:show.sync="news_modal"
			>
			<p v-html="news_text"></p>
			<template #footer>
				<CButton @click="news_modal=false" color="primary">بستن</CButton>
			</template>
		</CModal>
        <CModal
			title="آمار اپراتورها"
			size="sm"
			color="primary"
			:show.sync="operators_modal"
			>
			<div v-for="(item, index) in operators" :key="index">
                <p>{{item.key}}: {{item.value}}</p>
            </div>
			<template #footer>
				<CButton @click="operators_modal=false" color="primary">بستن</CButton>
			</template>
		</CModal>
        <CModal
			title="آمار پیام‌ها"
			size="sm"
			color="primary"
			:show.sync="messages_modal"
			>
			<p>تعداد پیام‌ها: {{items[1]}}</p>
            <p>تعداد مسدود‌: {{items[2]}}</p>
            <p>تعداد نامشخص‌: {{items[3]}}</p>
            <p>تعداد تحویل‌ داده ‌شده‌: {{items[4]}}</p>
            <p>تعداد تحویل‌ داده ‌نشده‌: {{items[5]}}</p>
			<template #footer>
				<CButton @click="messages_modal=false" color="primary">بستن</CButton>
			</template>
		</CModal>
    </div>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
export default {
    components: { ModelSelect },
    data() {
        return {
            items: [],
            page: 1,
            page_count: 0,
            offset: 0,
            limit: 10,
            fields: [
                { key: 'news_title', label: 'عنوان' },
                { key: 'published_at', label: 'تاریخ انتشار' },
            ],
            news: [],
            news_text: null,
            operators: [],
            news_modal: false,
            operators_modal: false,
            messages_modal: false,
            operators_count: 0,
            collapse: false,
            users: [],
            series: [
                {
                    name: "ورودی",
                    data: []
                },
                {
                    name: "خروجی",
                    data: []
                },
                {
                    name: "در صف",
                    data: []
                }
            ],
            chartOptions: {
                chart: {
                height: 350,
                type: 'line',
                dropShadow: {
                    enabled: true,
                    color: '#000',
                    top: 18,
                    left: 7,
                    blur: 10,
                    opacity: 0.2
                },
                toolbar: {
                    show: true
                }
                },
                colors: ['#008FFB', '#00E396', '#545454'],
                dataLabels: {
                    enabled: true,
                },
                stroke: {
                    curve: 'smooth'
                },
                title: {
                    text: 'نمودار گزارش لحظه‌ای',
                    align: 'left',
                    style: {
                        color:  '#ffffff'
                    },
                },
                grid: {
                    borderColor: '#e7e7e7',
                    row: {
                        colors: ['#f3f3f3', 'transparent'],
                        opacity: 0.5
                    },
                },
                markers: {
                    size: 1
                },
                xaxis: {
                    categories: [],
                    title: {
                        text: 'ساعت/دقیقه'
                    }
                },
                yaxis: {
                    show: false
                },
                legend: {
                    position: 'top',
                    horizontalAlign: 'right',
                    floating: true,
                    offsetY: -25,
                    offsetX: -5
                }
            },
        }
    },
    watch: {
        page: {
            handler() {
                this.get();
            }
        },
        '$store.state.created_at': {
            handler(){
                this.chartOptions = {...this.chartOptions, ...{
                    xaxis:{
                        categories: this.$store.state.created_at
                    }
                }}
                this.series = [
                    {data: this.$store.state.send_sms_count}, 
                    {data: this.$store.state.rcv_sms_count}, 
                    {data: this.$store.state.in_queue_sms_count}
                ];
            }
        }
    },
    mounted() {
        this.get_dashboard();
        if(this.$store.state.perms.can_view_monitoring_page){
			this.get_users();
		}
        this.chartOptions = {...this.chartOptions, ...{
            xaxis:{
                categories: this.$store.state.created_at
            }
        }}
        this.series = [
            {data: this.$store.state.send_sms_count}, 
            {data: this.$store.state.rcv_sms_count}, 
            {data: this.$store.state.in_queue_sms_count}
        ];
        this.get();
    },
    methods: {
        get_dashboard(){
            this.axios.get('/users/'
                + '?id=' + this.$store.state.user_id
                + '&user_statistics=1')
                .then(res => {
                    let tmp = res.data[0].user_statistics[0].user_statistics;
                    this.items.push(
                        this.$moment(tmp.day, 'YYYY-MM-DD').locale('fa').format('jYYYY-jMM-jDD'),
                        String(tmp.messages_infos.all_messages.count).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                        String(tmp.messages_infos.blocked_messages.count).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                        String(tmp.messages_infos.unknown_messages.count).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                        String(tmp.messages_infos.delivered_messages.count).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                        String(tmp.messages_infos.undelivered_messages.count).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                        String(tmp.messages_infos.all_messages.sms_fee).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                        String(tmp.messages_infos.returned_fee).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                    );
                    let i = 0;
                    for (const [key, value] of Object.entries(tmp.operator_infos)) {
                        i++;
                        this.operators.push({key: key, value: String(value.all_messages.count).replace(/\B(?=(\d{3})+(?!\d))/g, ",")})
                    }
                    this.operators_count = i;
                })
        },
        get() {
            this.axios.get('news/'
                + '?count=1')
                .then(res => {
                    this.row_count = String(res.data.count).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    if(res.data.count > 100){
                        this.page_count = Math.ceil(res.data.count / 100);
                    } else {
                        this.page_count = 1;
                    }
                    this.offset = 0;
                    if(this.page != 1){
                        this.offset = (this.page * 100) - 99;
                    }
                })
            .finally(() => {
                this.axios.get('news/' 
                    + '?limit=' + this.limit 
                    + '&offset=' + this.offset)
                    .then(res => {
                        res.data.map(val => {
                            val.published_at = this.$moment(val.published_at, 'YYYY-MM-DD HH:mm').locale('fa').format('HH:mm jYYYY-jMM-jDD');
                        });
                        this.news = res.data;
                    })
            })
        },
        get_users(){
            this.axios.get('users/?type=view_user_send_rcv_into')
                .then(res => {
                    res.data.map(val => {
                        this.users.push({ value: val.id, text: `${val.id} - ${val.name}` });
                    });
                })
        },
        get_chart(){
            this.axios.get('get_time')
                .then(res => {
                    const today = res.data.current_date.split(' ');
                    this.axios.get('send_rcv_info/'
                        + '?created_at=' + today[0]
                        + '&user_id=' + this.$store.state.u_id
                        + '&limit=20'
                        + '&offset=1')
                        .then(res => {
                            res.data.map(val => {
                                this.$store.commit('rest_send_sms_count', val.send_sms_count);
                                this.$store.commit('rest_rcv_sms_count', val.rcv_sms_count);
                                this.$store.commit('rest_in_queue_sms_count', val.in_queue_sms_count);
                                let created_at = this.$moment(val.created_at, 'YYYY-MM-DD HH:mm').locale('fa').format('HH:mm jYYYY-jMM-jDD').split(' ');
                                this.$store.commit('rest_created_at', created_at[0]);
                            });
                        })
                }) 
        },
        filter(){
            this.$store.commit('empty_chart');
            this.get_chart();
        },
        remove_filter(){
            this.$store.commit('empty_chart');
            this.$store.commit('set_u_id', this.$store.state.user_id);
            this.get_chart();
        }
    },
}
</script>